<template>
  <div class="payment-wrapper">
    <div class="payment-processed">
      <img src="../../../../assets/success.svg" alt="" />
      <p class="success-text my-3">
        {{$t('message.successTitle')}}.</p
      >
      <p class="payment-text mb-0 mt-3"
        >
        {{ $t("message.successTransactionMessage") }} : {{transactionId}}
        </p
      >
      <div class="mt-3 success-buttons">
        <b-button
        @click="nextPage()"
        class="another-page-button next-button-color btn-ripple mx-auto"
        variant="light"
        >{{$t('message.selectAnotherStore')}}</b-button
      >
      <b-button
        @click="goToHomePage()"
        class="another-page-button next-button-color btn-ripple mt-3 mx-auto"
        variant="white"
        >{{$t('message.goToHomePage')}}</b-button
      >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "payment-processed",
  data () {
    return {
      transactionId: null
    }
  },
  beforeMount () {
    this.transactionId = this.$route.params.transactionId
  },
  mounted () {
    window.onbeforeunload = function() { return "Your work will be lost."; };
    this.$store.commit('updateSelectedManagers', [])
    this.$store.commit('updateAssingedManagers', {})
    this.$store.commit('updateManagersNames', [])
    this.$store.commit('changeStoreName', '')
  },
  methods: {
    nextPage() {
      this.$router.push(`/`);
    },
    goToHomePage () {
      window.parent.location.href = this.$store.getters.domain;
    }
  },
};
</script>

<style lang="scss" scoped>

.payment-processed {
  text-align: center;
  margin: 10% auto;
  max-width: 678px;
  border: none;
  padding: 10px;
}

.success-text {
  display: block;
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  color: #000000;
}

.payment-text {
  font-weight: normal;
  font-size: 18px;
  text-align: center;
  color: #4f4f4f;
  display: block;
  margin-bottom: 20px;
}

.payment-text-small {
  font-weight: normal;
  font-size: 14px;
  text-align: center;
  color: #4f4f4f;
  display: block;
}

.payment-wrapper {
  min-height: 100vh;
  display: flex;
  justify-content: center;
}

.another-page-button {
  min-width: 270px;
  padding: 12px;
  display: unset;
  border-radius: 4px;
  border: none;
}

.go-to-homepage-button {
  min-width: 270px;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid;
}


.success-buttons{
  display: grid;
}

</style>